import moment from "moment";
import { Button } from "primereact/button";
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { FaArrowLeft, FaArrowRight, FaPrint } from "react-icons/fa6";
import QRCode from "react-qr-code";
import { useLocation, useNavigate } from "react-router-dom";
import SharedButton from "../components/Shared/SharedButton";

const P2PInsuranceInvoice = () => {
  const navigate = useNavigate();
  const { t,i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const iframeRef = useRef(null);
  const invoiceRef = useRef(null);
  const location = useLocation();
  const { invoiceData } = location.state;
  const module = location?.state?.module;
  const path = location?.state?.path;
  const revoke = location?.state?.revoke;

  const handlePrint = () => {
    const printContents = invoiceRef.current.innerHTML;
    const iframe = iframeRef.current;
    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write("<html><head><title>Invoice</title>");
    doc.write(`
      <html>
        <head>
          <title>Invoice</title>
            <script src="https://cdn.tailwindcss.com"></script>
          <style>
            body { font-family: Arial, sans-serif; padding: 20px; }
            .zatca-invoice { max-width: 800px; margin: auto; }
          </style>
        </head>
        <body>
          ${printContents}
        </body>
      </html>
    `);
    doc.close();
    iframe.onload = () => {
      iframe.contentWindow.print();
    };
  };

  return (
    <div>
      <div>
        <div className="flex gap-3 mb-2">
          <SharedButton
            label={t("Back")}
            icon={isRTL ? <FaArrowRight /> : <FaArrowLeft />}
            onClick={() =>
              navigate(path, {
                state: { activeTab: module, childIndex: revoke ? 1 : 0 },
              })
            }
          />

          <SharedButton 
          label={t("PrintInvoice")}
          icon={<FaPrint />}
          onClick={handlePrint}
          />
        </div>
      </div>
      <div ref={invoiceRef}>
        <div className="max-w-4xl mx-auto bg-white border-2 border-[#333] rounded">
          <div className="w-full flex items-center justify-between border-b-2 border-b-[#333] rounded-t">
            <div className="flex flex-col bg-red-800 px-[2px] py-2 print:bg-red-800">
              <h3 className="text-white font-semibold text-[15px] text-center print:text-black">
                HUSSAM COMPANY LTD <br />
                OPTICAL DIVISION
              </h3>
              <div className="mt-1">
                <p className="text-[12px] text-center text-white font-semibold print:text-black">
                  C.R: &nbsp; <span>{invoiceData?.business?.cr_no}</span>
                </p>
              </div>
            </div>
            <div>
              <img
                src="/images/hussam_logo.jpeg"
                className="w-[200px] h-[70px]"
                alt="logo"
              />
            </div>
            <div className="flex flex-col text-center px-[2px]">
              <h3 className="text-gray-800 font-semibold text-[15px]">
                شـــــركة حســـــام المحدودة <br />
                قسم البصريات
              </h3>
              <div className="mt-1">
                <p className="text-[12px] text-center text-gray-800 font-semibold print:text-black">
                  س ت: &nbsp; <span>{invoiceData?.business?.cr_no}</span>
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center justify-between  px-[2px]">
            <div className="w-[175px] break-words">
              <p>{invoiceData?.insurance_company?.tpa_name_en}</p>
            </div>
            <div className="flex-1 flex flex-col items-center">
              <h2 className="text-[16px] font-semibold text-gray-800">
                {revoke ? "CREDIT NOTE" : "TAX INVOICE"}
              </h2>
              <h3 className="text-lg text-gray-700">
                {revoke ? "إشعار دائن" : "الفاتورة الضريبية"}
              </h3>
            </div>
            <div className="w-[175px] break-words"></div>
          </div>
          <div className="mb-4">
            <table className="w-full border-collapse">
              <tbody>
                <tr className="">
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] border-l-0 font-medium ">
                    Provider VAT number (registered)
                  </td>
                  <td className=" text-[12px] border-2 px-[2px] border-[#333] text-center">
                    {invoiceData?.business?.vat_no}
                  </td>
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] text-right border-r-0 ">
                    رقم التسجيل الضريبي للمورد
                  </td>
                </tr>
                <tr className="">
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] font-medium border-l-0 ">
                    Provider Code
                  </td>
                  <td className=" text-[12px] border-2 px-[2px] border-[#333] text-center">
                    {invoiceData?.insurance_company?.provider_code}
                  </td>
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] text-right border-r-0 ">
                    رقم المورد
                  </td>
                </tr>
                <tr className="">
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] font-medium border-l-0 ">
                    Provider name
                  </td>
                  <td className=" text-[12px] border-2 px-[2px] border-[#333] text-center">
                    {invoiceData?.business?.name_en}
                  </td>
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] text-right border-r-0 ">
                    اسم المورد بالكامل
                  </td>
                </tr>
                <tr className="">
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] font-medium border-l-0 ">
                    Provider CR number
                  </td>
                  <td className=" text-[12px] border-2 px-[2px] border-[#333] text-center">
                    {" "}
                    {invoiceData?.business?.cr_no}
                  </td>
                  <td className=" text-[12px] border-2 px-[2px] border-[#333] text-right border-r-0 ">
                    رقم السجل التجاري للمورد
                  </td>
                </tr>
                <tr className="">
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] font-medium border-l-0 ">
                    Summary Tax Invoice number
                  </td>
                  <td className="text-center text-[12px] border-2 px-[2px] border-[#333] ">
                    {invoiceData?.invoice_no}
                  </td>
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] text-right border-r-0 ">
                    رقم ملخص الفاتورة الضريبية
                  </td>
                </tr>
                {revoke && (
                  <tr>
                    <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] font-medium border-l-0">
                      Reference Number
                    </td>
                    <td className="text-center text-[12px] border-2 px-[2px] border-[#333]">
                      {invoiceData?.refrence}
                    </td>
                    <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] text-right border-r-0">
                      رقم المرجع
                    </td>
                  </tr>
                )}
                <tr className="">
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] font-medium border-l-0 ">
                    Invoice issue date
                  </td>
                  <td className="text-center text-[12px] border-2 px-[2px] border-[#333] ">
                    {moment(invoiceData?.date).format("DD-MM-YYYY HH:mm")}
                  </td>
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] text-right border-r-0 ">
                    تاريخ إصدار الفاتورة
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Buyer Information */}
          <div className="mb-4">
            <table className="w-full mt-2 border-collapse">
              <tbody>
                <tr className="">
                  <td className="!w-[120px] text-[12px] font-bold border-2 border-b-0 px-[2px] border-[#333] border-l-0 ">
                    Full name of the Buyer
                  </td>
                  <td className="!w-[270px] text-[12px]  border-2 border-b-0 px-[2px] border-[#333] font-bold border-l-0 text-red-500 ">
                    {invoiceData?.insurance_company?.name_en}
                  </td>
                  <td className=" text-[12px]  border-2 border-b-0 px-[2px] border-[#333] font-bold border-r-0 text-right text-red-500 ">
                    {invoiceData?.insurance_company?.name_ar}
                  </td>
                  <td className="!w-[120px] text-[12px]  border-2 border-b-0 px-[2px] border-[#333] font-bold border-r-0 text-right ">
                    اسم العميل بالكامل
                  </td>
                </tr>
              </tbody>
            </table>
            <table className="w-full border-collapse">
              <tbody>
                <tr className="">
                  <td className="!w-[210px] text-[12px] border-2 px-[2px] border-[#333] border-l-0 ">
                    Buyers VAT number (registered)
                  </td>
                  <td className=" text-[12px]  border-2 px-[2px] border-[#333] border-l-0 text-center ">
                    {invoiceData?.insurance_company?.vat_no}
                  </td>
                  <td className="!w-[210px] text-[12px]  border-2 px-[2px] border-[#333] border-r-0 text-right ">
                    رقم تسجيل ضريبية القيمة المضافة للعميل
                  </td>
                </tr>
              </tbody>
            </table>
            {invoiceData?.insurance_company?.tpa_name_en === "BUPA" ? (
              <table className="w-full border-collapse mt-2 text-[12px]">
                <tbody>
                  <tr>
                    <td className="!w-[70px] text-right border-2 border-[#333] border-l-0 px-[4px] py-2 font-semibold">
                      Attention
                    </td>
                    <td className="text-center border-2 border-[#333] px-[4px] py-2 border-l-0 border-r-0">
                      Bupa Arabia for Cooperative Insurance and its subsidiaries
                      شركة بوبا العربية للتأمين التعاوني وشركاتها التابعة
                    </td>
                    <td className="!w-[70px] text-left border-2 border-[#333] border-r-0 px-[4px] py-2 font-semibold">
                      موجه إلى
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : (
              <table className="w-full border-collapse mt-2 text-[12px]">
                <tbody>
                  <tr>
                    <td className="!w-[70px] border-2 border-[#333] border-l-0 px-[4px] py-4 text-center"></td>
                    <td className="border-2 border-[#333] px-[4px] py-4 border-l-0 border-r-0 text-center"></td>
                    <td className="!w-[70px] border-2 border-[#333] border-r-0 px-[4px] py-4 text-center"></td>
                  </tr>
                </tbody>
              </table>
            )}
          </div>

          <div className="flex items-center border-2 border-[#333] border-l-0 border-r-0">
            <div>
              <p className="text-[12px] font-bold px-[2px] w-[70px] text-center">
                Buyers full address
              </p>
            </div>
            <div className="flex-1">
              <table className="w-full border-collapse">
                <tbody>
                  <tr>
                    <td className="!w-[140px] text-[12px] border-2 border-t-0 border-b-0 px-[2px] border-[#333] ">
                      Street
                    </td>
                    <td className="text-center !w-[180px] text-[12px]  border-2 border-t-0 border-b-0 px-[2px] border-[#333]  ">
                      {invoiceData?.insurance_company?.street_en}
                    </td>
                    <td className=" !w-[180px] text-[12px]  border-2 border-t-0 border-b-0 px-[2px] border-[#333]  text-center  ">
                      {invoiceData?.insurance_company?.street_ar}
                    </td>
                    <td className="!w-[140px] text-[12px]  border-2 border-t-0 border-b-0 px-[2px] border-[#333]  text-right ">
                      الشارع الرئيسي
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      Building number
                    </td>
                    <td
                      className=" text-[12px]  border-2 px-[2px] border-[#333]  text-center"
                      colSpan={2}
                    >
                      {invoiceData?.insurance_company?.building_number}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      رقم المبنى
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      Additional number
                    </td>
                    <td
                      className=" text-[12px]  border-2 px-[2px] border-[#333]  text-center"
                      colSpan={2}
                    >
                      {invoiceData?.insurance_company?.additional_number}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      {" "}
                      رقم إضافي
                    </td>
                  </tr>
                  {/* <tr>
                    <td className=' text-[12px]  border-2 px-[2px] border-[#333]  '>
                      Building number
                    </td>
                    <td
                      className=' text-[12px]  border-2 px-[2px] border-[#333]  text-center'
                      colSpan={2}
                    >
                      6507
                    </td>
                    <td className='text-[12px]  border-2 px-[2px] border-[#333]  text-right '>
                      رقم المبنى
                    </td>
                  </tr> */}
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      City
                    </td>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333] text-center">
                      {invoiceData?.insurance_company?.city_en}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-center ">
                      {invoiceData?.insurance_company?.city_ar}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      {" "}
                      المدينة
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      Postal code
                    </td>
                    <td
                      className=" text-[12px]  border-2 px-[2px] border-[#333]  text-center"
                      colSpan={2}
                    >
                      {invoiceData?.insurance_company?.postal_code}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      {" "}
                      الرمز البريدي
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      Province/State
                    </td>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333] text-center">
                      {invoiceData?.insurance_company?.state_en}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-center ">
                      {invoiceData?.insurance_company?.state_ar}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      {" "}
                      المنطقة
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      District/Neighborhood
                    </td>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333] text-center">
                      {invoiceData?.insurance_company?.district_en}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-center ">
                      {invoiceData?.insurance_company?.district_ar}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      {" "}
                      الحي
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333] border-b-0  ">
                      Country code
                    </td>
                    <td
                      className=" text-[12px]  border-2 px-[2px] border-[#333] border-b-0  text-center"
                      colSpan={2}
                    >
                      {invoiceData?.insurance_company?.country_code}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333] border-b-0  text-right ">
                      {" "}
                      رمز البلد
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <p className=" text-[12px] font-bold px-[2px] text-center w-[70px]">
                عنوان العميل كامل
              </p>
            </div>
          </div>

          <div className="flex items-center border-2 border-[#333] border-l-0 border-r-0 mt-2">
            <div>
              <p className="text-[12px] font-bold px-[2px] w-[70px] text-center">
                Providers full address
              </p>
            </div>
            <div className="flex-1">
              <table className="w-full border-collapse">
                <tbody>
                  <tr>
                    <td className="!w-[140px] text-[12px] border-2 border-t-0 border-b-0 px-[2px] border-[#333] ">
                      Street
                    </td>
                    <td className="!w-[180px] text-center text-[12px]  border-2 border-t-0 border-b-0 px-[2px] border-[#333]  ">
                      {invoiceData?.business?.additionalStreetAddress}
                    </td>
                    <td className="!w-[180px] text-[12px]  border-2 border-t-0 border-b-0 px-[2px] border-[#333]  text-right  ">
                      {invoiceData?.business?.street_ar}
                    </td>
                    <td className="!w-[140px] text-[12px]  border-2 border-t-0 border-b-0 px-[2px] border-[#333]  text-right ">
                      الشارع الرئيسي
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      Building number
                    </td>
                    <td
                      className=" text-[12px]  border-2 px-[2px] border-[#333]  text-center"
                      colSpan={2}
                    >
                      {invoiceData?.business?.buildingNumber}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      رقم المبنى
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      Additional number
                    </td>
                    <td
                      className=" text-[12px]  border-2 px-[2px] border-[#333]  text-center"
                      colSpan={2}
                    >
                      {invoiceData?.business?.additional_number}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      {" "}
                      رقم إضافي
                    </td>
                  </tr>
                  {/* <tr>
                    <td className=' text-[12px]  border-2 px-[2px] border-[#333]  '>
                      Building number
                    </td>
                    <td
                      className=' text-[12px]  border-2 px-[2px] border-[#333]  text-center'
                      colSpan={2}
                    >
                      6507
                    </td>
                    <td className='text-[12px]  border-2 px-[2px] border-[#333]  text-right '>
                      رقم المبنى
                    </td>
                  </tr> */}
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      City
                    </td>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333] text-center">
                      {invoiceData?.business?.city}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-center ">
                      {" "}
                      {invoiceData?.business?.cityName}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      {" "}
                      المدينة
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      Postal code
                    </td>
                    <td
                      className=" text-[12px]  border-2 px-[2px] border-[#333]  text-center"
                      colSpan={2}
                    >
                      {invoiceData?.business?.postalCode}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      {" "}
                      الرمز البريدي
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      Province/State
                    </td>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333] text-center">
                      {invoiceData?.business?.state_en}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-center ">
                      {" "}
                      {invoiceData?.business?.state_ar}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      {" "}
                      المنطقة
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333]  ">
                      District/Neighborhood
                    </td>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333] text-center">
                      {invoiceData?.business?.neighborhood_en}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-center ">
                      {" "}
                      {invoiceData?.business?.neighborhood_ar}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333]  text-right ">
                      {" "}
                      الحي
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px]  border-2 px-[2px] border-[#333] border-b-0  ">
                      Country code
                    </td>
                    <td
                      className=" text-[12px]  border-2 px-[2px] border-[#333] border-b-0  text-center"
                      colSpan={2}
                    >
                      {invoiceData?.business?.countryCode}
                    </td>
                    <td className="text-[12px]  border-2 px-[2px] border-[#333] border-b-0  text-right ">
                      {" "}
                      رمز البلد
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <p className=" text-[12px] font-bold px-[2px]  w-[70px] text-center">
                {" "}
                عنوان مزود الخدمة
              </p>
            </div>
          </div>

          <div className="flex items-center border-2 border-[#333] border-l-0 border-r-0 mt-2">
            <div>
              <p className="text-[12px] font-bold px-[2px] w-[70px] text-center">
                Invoice Details
              </p>
            </div>
            <div className="flex-1">
              <table className="w-full border-collapse">
                <tbody>
                  <tr>
                    <td className="!w-[140px] text-[10px]  border-2 border-t-0 border-b-0 px-[2px] border-[#333]  ">
                      {revoke ? "Description" : "Special Transaction Type"}
                    </td>
                    <td className="!w-[180px] text-[12px]  border-2 border-t-0 border-b-0 px-[2px] border-[#333]  text-center">
                      {revoke
                        ? invoiceData?.revoked_reason
                        : "Summary Tax Invoice"}
                    </td>
                    <td className="!w-[180px] text-[12px]  border-2 border-t-0 border-b-0 px-[2px] border-[#333]  text-center ">
                      {revoke ? " " : "ملخص الفاتورة الضريبية "}
                    </td>
                    <td className="!w-[140px] text-[12px]  border-2 border-t-0 border-b-0 px-[2px] border-[#333]  text-right ">
                      {revoke ? " الوصف" : "  نوع المعاملة الخاصة"}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="w-full border-collapse">
                <tbody>
                  <tr>
                    <td className="!w-[250px] text-[12px] border-2 px-[2px] border-[#333]  ">
                      Period/ Month of Supply
                    </td>
                    <td
                      className=" text-[12px] border-2 px-[2px] border-[#333] text-red-500 text-center"
                      colSpan={2}
                    >
                      {`${invoiceData?.month}/${invoiceData?.year}`}
                    </td>
                    <td className="!w-[250px] text-[12px] border-2 px-[2px] border-[#333]  text-right ">
                      فترة / شهر التوريد
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333]  ">
                      Description/ Nature of service
                    </td>
                    <td
                      className=" text-[12px] border-2 px-[2px] border-[#333] text-center "
                      colSpan={2}
                    >
                      OPTICAL
                    </td>
                    <td className="text-[12px] border-2 px-[2px] border-[#333]  text-right ">
                      الوصف / طبيعة الخدمة
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333]  ">
                      Total Gross Excluding VAT
                    </td>
                    <td
                      className=" text-[12px] border-2 px-[2px] border-[#333] text-center "
                      colSpan={2}
                    >
                      {invoiceData?.total_gross}
                    </td>
                    <td className="text-[12px] border-2 px-[2px] border-[#333]  text-right ">
                      إجمالي المبلغ غير شامل ضريبة القيمة المضافة
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333]  ">
                      Total Discount Applied
                    </td>
                    <td
                      className=" text-[12px] border-2 px-[2px] border-[#333] text-center "
                      colSpan={2}
                    >
                      {invoiceData?.total_discount || "00.00"}
                    </td>
                    <td className="text-[12px] border-2 px-[2px] border-[#333]  text-right ">
                      إجمالي مبلغ الخصومات
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333]">
                      Total Deductible Amount
                    </td>
                    <td
                      className=" text-[12px] border-2 px-[2px] border-[#333] text-center"
                      colSpan={2}
                    >
                      {invoiceData?.total_deduction || "00.00"}
                    </td>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333] text-right">
                      إجمالي مبلغ نسبة التحمل
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333]">
                      Taxable Amount (Standard Rated-15%)
                    </td>
                    <td
                      className=" text-[12px] border-2 px-[2px] border-[#333] text-center"
                      colSpan={2}
                    >
                      00.00
                    </td>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333] text-right">
                      إجمالي المبيعات الخاضعة للنسبة المؤية ( 15% )
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333]">
                      Taxable Amount (Zero Rated)
                    </td>
                    <td
                      className=" text-[12px] border-2 px-[2px] border-[#333] text-center"
                      colSpan={2}
                    >
                      {invoiceData?.total_net || "00.00"}
                    </td>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333] text-right">
                      اجمالي المبيعات الخاصة للنسبة الصفرية (0%)
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333]">
                      Total Net Amount
                    </td>
                    <td
                      className=" text-[12px] border-2 px-[2px] border-[#333] text-center"
                      colSpan={2}
                    >
                      {invoiceData?.total_net || "00.00"}
                    </td>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333] text-right">
                      إجمالي صافي المبلغ
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333]">
                      Applied % VAT
                    </td>
                    <td
                      className=" text-[12px] border-2 px-[2px] border-[#333] text-center"
                      colSpan={2}
                    >
                      00.00%
                    </td>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333] text-right">
                      نسبة الضريبة المضافة
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333]">
                      Amount VAT
                    </td>
                    <td
                      className=" text-[12px] border-2 px-[2px] border-[#333] text-center"
                      colSpan={2}
                    >
                      00.00
                    </td>
                    <td className=" text-[12px] border-2 px-[2px] border-[#333] text-right">
                      قيمة الضريبة المضافة
                    </td>
                  </tr>
                  <tr>
                    <td className=" text-[12px] border-2 border-b-0 px-[2px] border-[#333]">
                      Total Amount Including VAT
                    </td>
                    <td
                      className=" text-[12px] border-2 border-b-0 px-[2px] border-[#333] text-red-500 text-center"
                      colSpan={2}
                    >
                      {invoiceData?.total_net || "00.00"}
                    </td>
                    <td className=" text-[12px] border-2 border-b-0 px-[2px] border-[#333] text-right">
                      إجمالي المبلغ شامل الضريبة
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div>
              <p className=" text-[12px] font-bold px-[2px] text-center w-[70px]">
                تفاصيل الفاتورة{" "}
              </p>
            </div>
          </div>
          <div className="p-2">
            <div className="flex items-start justify-between">
              <QRCode
                size={60}
                style={{ height: 60, maxWidth: "100%", width: 60 }}
                value={invoiceData?.qr_code || ""}
                viewBox="0 0 256 256"
              />

              <p className="text-[12px] font-semibold">Signature and Stamp</p>
              <p className="text-[12px] font-semibold"> التوقع و الختم</p>
            </div>
            {/* <div className='py-1'></div> */}
          </div>
        </div>
        <div className="max-w-4xl mx-auto bg-white mt-2 flex items-center">
          <p className="text-[12px] font-semibold text-right w-full">
            <span className="text-blue-800">info@hussamoptics.com</span>
            المملكة العربية السعودية - جدة (6657805-012 - 6674241-012 -
            6611664-012) - اشتراك الغرفة (17272) - فاكس
          </p>
        </div>
      </div>

      <iframe ref={iframeRef} style={{ display: "none" }}></iframe>
    </div>
  );
};

export default P2PInsuranceInvoice;
